import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { TemplateTypeMenuButton } from "./TemplateTypeMenuButton";

const i18nRoot = "settings.workflows.table.type";

export type TemplateType = "all" | "bulk_action" | "dynamic";

interface Option {
  label: string;
  value: TemplateType;
}

const OPTIONS: Option[] = [
  {
    label: t([i18nRoot, "all"]),
    value: "all",
  },
  {
    label: t([i18nRoot, "dynamic"]),
    value: "dynamic",
  },
  {
    label: t([i18nRoot, "bulk_action"]),
    value: "bulk_action",
  },
];

export const TemplateTypeDropdown = ({
  selectedTemplateType,
  setSelectedTemplateType,
}: {
  selectedTemplateType: TemplateType;
  setSelectedTemplateType: (value: TemplateType) => void;
}) => {
  const handleOnChange = (value: string) => {
    setSelectedTemplateType(value as TemplateType);
  };

  return (
    <Dropdown
      className="!mt-2 w-fit"
      direction="bottom-start"
      menuButtonEl="div"
      menuWrapperClassName="!mt-0"
      transitionWrapperClassName="z-20"
      onChange={handleOnChange}
      activeOptionValue={selectedTemplateType}
      button={
        <TemplateTypeMenuButton selectedTemplateType={selectedTemplateType} />
      }
      options={OPTIONS}
    />
  );
};
